import ApiService from "@/common/api.service";

const PATH = "stock/transfer-orders";

export const GET_STOCK_TRANSFER_ORDERS = "getStockTransferOrders";
export const GET_STOCK_TRANSFER_ORDER = "getStockTransferOrder";
export const GET_STOCK_TRANSFER_ORDER_ACTIONABLE_SUMMARY =
  "getStockTransferOrderActionableSummary";
export const CREATE_STOCK_TRANSFER_ORDER = "createStockTransferOrder";
export const UPDATE_STOCK_TRANSFER_ORDER = "updateStockTransferOrder";
export const CONFIRM_STOCK_TRANSFER_ORDER = "confirmStockTransferOrder";
export const SHIP_STOCK_TRANSFER_ORDER = "shipStockTransferOrder";
export const RECEIVE_STOCK_TRANSFER_ORDER = "receiveStockTransferOrder";
export const RESOLVE_STOCK_TRANSFER_ORDER_VARIANCE = "resolveStockTransferOrderVariance";
export const CANCEL_STOCK_TRANSFER_ORDER = "cancelStockTransferOrder";
export const GET_STOCK_TRANSFER_ORDER_SUGGEST_DRAFT_LOTS =
  "getStockTransferOrderSuggestDraftLots";

const state = {
  actionableSummary: {
    to_ship: 0,
    to_receive: 0,
    total: 0,
  },
};

const getters = {
  stockTransferOrderActionableTotal(state) {
    return Number(state.actionableSummary?.total || 0);
  },
  stockTransferOrderActionableSummary(state) {
    return state.actionableSummary;
  },
};

const actions = {
  [GET_STOCK_TRANSFER_ORDERS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSFER_ORDER_ACTIONABLE_SUMMARY](context) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/actionable-summary`, {
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => {
          const summary = data.data || data || {};
          context.commit("setActionableSummary", {
            to_ship: Number(summary.to_ship || 0),
            to_receive: Number(summary.to_receive || 0),
            total: Number(summary.total || 0),
          });
          resolve(summary);
        })
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSFER_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_TRANSFER_ORDER](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_TRANSFER_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CONFIRM_STOCK_TRANSFER_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/confirm`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [SHIP_STOCK_TRANSFER_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/ship`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [RECEIVE_STOCK_TRANSFER_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/receive`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [RESOLVE_STOCK_TRANSFER_ORDER_VARIANCE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/resolve-variance`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_TRANSFER_ORDER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSFER_ORDER_SUGGEST_DRAFT_LOTS](context, payload) {
    const params = (payload && payload.params) || {};

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/suggest-lots`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations: {
    setActionableSummary(state, summary) {
      state.actionableSummary = {
        to_ship: Number(summary?.to_ship || 0),
        to_receive: Number(summary?.to_receive || 0),
        total: Number(summary?.total || 0),
      };
    },
  },
};
